import React from 'react'

import InfiniteScroll from "react-infinite-scroll-component";

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

import './Entropy.scss';

let strings = new LocalizedStrings({
    en:{
        title:"entropy",

        description:"scroll down for entropy!"
    },
    de: {
        title:"entropie",

        description:"scrolle hinunter, der entropie entgegen!"
    }
});

class Entropy extends React.Component {
    constructor(props) {
        super(props)

        this.deviationFact = 1.01
        this.deviation = 1
        this.lastLine = Array.from({length: strings.title.length}, (_) => 0)
        var lines = [this.lastLine]

        for (var i = 0; i < 200; i++) {
            this.newLine()
            lines.push(this.lastLine)
        }

        this.state = {lines: lines}
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    newLine = () => {
        this.lastLine = this.lastLine.map((offs, _) => offs-this.deviation+Math.random()*this.deviation*2)
        this.deviation *= this.deviationFact
    }

    fetchMoreData = () => {
        var lines = []
        for(var i = 0; i < 12; i++) {
            this.newLine()
            lines.push(this.lastLine)
        }

        this.setState({
            lines: this.state.lines.concat(lines)
        });
    };

    render() {
        strings.setLanguage(this.context.language)
        return <div className="textDisplay">
            <InfiniteScroll
                dataLength={this.state.lines.length}
                next={this.fetchMoreData}
                hasMore={true}
                loader={<h4>Loading...</h4>}
            >
                {this.state.lines.map((line, index) => (
                    <p className="entropy" key={index}>
                        {line.map((offs, index) => (
                            <span key={index} style={{position: "relative", left: offs}}>
                                {strings.title.substring(index, index+1)}
                            </span>
                        ))}
                    </p>
                ))}
            </InfiniteScroll>
        </div>
    }
}
Entropy.contextType = LanguageContext

export default Entropy
